export function getDateInSeconds (date) {
  return (new Date(date)).getTime()/1000;
}

export function normalizeDateFormat(value) {

  value = value.replace(/\D/g,'').substring(0, 10);

  let dateString = value;
  const valueSplit = value.match(/.{1,2}/g);

  if(valueSplit) {
    if(valueSplit[0] !== undefined) {
      dateString = valueSplit[0];
      if(valueSplit[1] !== undefined) {
        dateString += '.' + valueSplit[1];
        if(valueSplit[2] !== undefined) {
          dateString += '.' + valueSplit[2];
          if(valueSplit[3] !== undefined) {
            dateString += valueSplit[3];
          }
        }
      }
    }
  }

  return dateString;
}
